module.exports = __webpack_public_path__ + "img/33_67.3445432d.png";